import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const CompanyDataContainer = styled.div({
  display: 'flex',
  flex: 1,
  justifyContent: 'space-between'
})

export const DataSection = styled.div({
  display: 'flex',
  flex: 1,
  marginRight: '10px',
  border: `solid 1px ${v.borderGray}`,
  flexDirection: 'column',

  '&:last-child': {
    marginRight: '0px',
  },

  'div.actionSection': {
    display: 'flex',
    width: '100%',
    padding: '5px',
    justifyContent: 'center',

    button: {
      fontSize: '10px'
    }
  },

  'div.searchSection': {
    display: 'flex',
    width: '100%',
    padding: '5px',

    'div.ui': {
      width: '100%'
    }
  },

  'div.dataSection': {
    padding: '5px',
  },
})